import { useEffect } from 'react';
import NaiveBayesView from './ui/naive-bayes-view';
import NaiveBayesParameters from './ui/naive-bayes-parameters';
import { useNaiveBayesClassifierStore } from './dal/naive-bayes-store';
import { INaiveBayesClassifierParameters } from './naive-bayes-interfaces';

const initialParameters: INaiveBayesClassifierParameters = {
    "titles": [
        "age", "income", "student", "credit_rating"
    ],
    "rows": [
        ["youth", "high", "no", "fair"],
        ["youth", "high", "no", "excellent"],
        ["middle_aged", "high", "no", "fair"],
        ["senior", "medium", "no", "fair"],
        ["senior", "low", "yes", "fair"],
        ["senior", "low", "yes", "excellent"],
        ["middle_aged", "low", "yes", "excellent"],
        ["youth", "medium", "no", "fair"],
        ["youth", "low", "yes", "fair"],
        ["senior", "medium", "yes", "fair"],
        ["youth", "medium", "yes", "excellent"],
        ["middle_aged", "medium", "no", "excellent"],
        ["middle_aged", "high", "yes", "fair"],
        ["senior", "medium", "no", "excellent"]
    ],
    "targetName": "buys_computer",
    "targetValues": [
        "no",
        "no",
        "yes",
        "yes",
        "yes",
        "no",
        "yes",
        "no",
        "yes",
        "yes",
        "yes",
        "yes",
        "yes",
        "no"
    ],
    "question":  ["youth", "medium", "yes", "fair"]
};

const NaiveBayesHome = () => {

    const params = useNaiveBayesClassifierStore(store => store.params);
    const setParams = useNaiveBayesClassifierStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">מסווג בייסיאני נאיבי</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <NaiveBayesParameters />
                        <NaiveBayesView />
                    </div>
                }
            </div>

        </div>
    )
};

export default NaiveBayesHome;
